import SecurityQuestionAnswerEntry from './SecurityQuestionAnswerEntry';

export default SecurityQuestionAnswerEntry;
